<div class="row" style="width: 100%;">
  <div class="col-12" style="width: 100%; height: 60vh; overflow: scroll">
    <form  >
      <json-editor [options]="editorOptions" [data]="data" >
      </json-editor>
    </form>
  </div>
</div>
